export const CREATE_SONG_URL = '/songs';
export const GET_SONGS_URL = '/songs';
export const CHECK_SONG_NAME_URL = '/songs/check-name';

// Song-scoped detail endpoints
export const GET_SONG_ALBUMS_URL = (id) => `/songs/${id}/albums`;
export const REMOVE_SONG_ALBUM_URL = (songId, albumId) => `/songs/${songId}/albums/${albumId}`;
export const GET_SONG_DISTRIBUTIONS_URL = (id) => `/songs/${id}/distributions`;
export const GET_SONG_RINGTONES_URL = (id) => `/songs/${id}/ringtones`;
export const REMOVE_SONG_RINGTONE_URL = (songId, ringtoneId) => `/songs/${songId}/ringtones/${ringtoneId}/remove`;
export const GET_SONG_VERSIONS_URL = (id) => `/songs/${id}/versions`;
export const ADD_SONG_RINGTONE_URL = (id) => `/songs/${id}/ringtones`;
export const GET_SONG_CONFLICTS_URL = (id) => `/songs/${id}/conflicts`;
export const CREATE_SONG_CONFLICT_URL = (id) => `/songs/${id}/conflicts`;
export const RESOLVE_SONG_CONFLICT_URL = (songId, conflictId) => `/songs/${songId}/conflicts/${conflictId}/resolve`;
export const DELETE_SONG_CONFLICT_URL = (songId, conflictId) => `/songs/${songId}/conflicts/${conflictId}/delete`;
export const INACTIVATE_CHECK_SONG_URL = (id) => `/songs/${id}/inactivate-check`;
export const INACTIVATE_SONG_URL = (id) => `/songs/${id}/inactivate`;
export const ACTIVATE_SONG_URL = (id) => `/songs/${id}/activate`;

